import React, { useState } from "react";
import useQueryString from "use-query-string";
import { useLocation, useHistory } from "react-router-dom";
import Button from "@material-ui/core/Button";
import { useSelector } from "react-redux";

import Typography from "@material-ui/core/Typography";
import Box from "@material-ui/core/Box";
import mixpanel from "mixpanel-browser";

import Dialog from "../../Theme/Dialog";

import { Container, Actions } from "./styles";

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box p={0}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

function AcaiTemplateNotify() {
  const location = useLocation();
  const history = useHistory();

  const [selectedTab, setSelectedtab] = useState(0);

  const alias = useSelector((state) => state.store.alias);
  const name = useSelector((state) => state.user.userData.name);

  const [{ openDialog }] = useQueryString(location);

  const open = openDialog === "acai-template-notify";

  function handleClose() {}

  return (
    <Dialog fullWidth open={open}>
      <TabPanel value={selectedTab} index={0}>
        <Container>
          <p>
            Como funciona <br /> <small>(Veja no video abaixo)</small>
          </p>
          <iframe
            style={{ width: "100%", height: "50vh" }}
            src="https://www.youtube.com/embed/TwSboGUGnkg?controls=0"
            title="YouTube video player"
            frameborder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowfullscreen
          ></iframe>
          <Actions>
            <Button
              variant="text"
              color="primary"
              size="medium"
              onClick={() => setSelectedtab(1)}
            >
              Continuar
            </Button>
          </Actions>
        </Container>
      </TabPanel>
      <TabPanel value={selectedTab} index={1}>
        <Container>
          <div>
            <p>
              Oii <strong>{name}</strong>, Nós preparamos um presente pra você!
              🎁
            </p>
            <p>
              Um Template de Açaiteria para você começar o mais rápido possivel
              a receber pedidos!
            </p>
            <p>
              Use e fique a vontade para fazer alterações que caracterizem seu
              cardápio. =)
            </p>
          </div>
          <Actions>
            <a target="_blank" href={`https://${alias}`}>
              Ver o meu cardápio
            </a>
            <Button
              variant="contained"
              color="primary"
              size="large"
              onClick={() => {
                mixpanel.track("View Açai Template Notify");
                history.replace("/");
              }}
            >
              Entendi
            </Button>
          </Actions>
        </Container>
      </TabPanel>
    </Dialog>
  );
}

export default AcaiTemplateNotify;
